export const preloadData = () => {
  const images = [require("@/assets/images/backgrounds/home.png")];
  const fonts = [
    // new FontFace(
    //     "Rubik",
    //     `url(${require("@/fonts/Rubik-Regular.ttf")}) format('truetype)'`
    // ),
    // new FontFace(
    //     "Rubik-Light",
    //     `url(${require("@/fonts/Rubik-Light.ttf")}) format('truetype)'`
    // ),
    // new FontFace(
    //     "RobotoMono-SemiBold",
    //     `url(${require("@/fonts/RobotoMono-SemiBold.ttf")}) format('truetype)'`
    // ),
  ];
  return {
    images,
    fonts,
  };
};
